export const ContentNotification = ({ content }) => {
  return (
    <div
      dangerouslySetInnerHTML={{ __html: content }}
      style={{ fontSize: '12px', margin: 0 }}
    ></div>
  )
}
export default ContentNotification
